export default class RegisteredMacAddressBatchService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('registeredMacAddresses', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/RegisteredMacAddressService.js